export type TInsuranceForecastSummary = {
    outstandingBalance: number;
    totalEstimatedEarnings: number;
    estimatedMonthlyTotalIncome: number;
    totalPayoutsReceived: number;
};

// "appointmentId": 752,
// "specialty": "Psychiatric & Mental Health",
// "appointmentGenFee": 8240,
// "appointmentGenFeeAmount": 82.40,
// "billingStatus": "SUCCEEDED",
// "appointmentOriginalDateTime": "2025-10-10T01:20:00",
// "appointmentEndDateTime": "2025-10-10T03:01:00",
// "rescheduledDateTime": null,
// "rescheduledEndDateTime": null,
// "appointmentDuration": 101,
// "transactionDate": "2025-10-10T02:59:01",
// "refundAmountCents": 0,
// "refundAmount": 0.00,
// "refundReason": "",
// "klarityTeamNotes": null,
// "stripeInvoiceId": "in_1SGWXfLWCWKPYTPjSRzq6aT3",
// "externalInvoicePlatform": "STRIPE",
// "externalInvoiceId": "in_1SGWXfLWCWKPYTPjSRzq6aT3",
// "invoiceId": "in_1SGWXfLWCWKPYTPjSRzq6aT3"

//   /**
//  * Appointment gen Fee (amount_cents)
//  */
// APPOINTMENT_GEN_FEE,
// /**
//  * Appointment original DATE & TIME (provider_appointment.start_at)
//  */
// APPOINTMENT_ORIGINAL_DATE_TIME,
// /**
//  * Rescheduled DATE & TIME (provider_appointment_reschedule.reschedule_at)
//  */
// RESCHEDULED_DATE_TIME,

// /**
//  * Transaction date (charge_succeed_at)
//  */
// TRANSACTION_DATE

export enum ELeadGenOrderKey {
    APPOINTMENT_GEN_FEE = 'APPOINTMENT_GEN_FEE',
    APPOINTMENT_DATE_TIME = 'APPOINTMENT_DATE_TIME',
    RESCHEDULED_DATE_TIME = 'RESCHEDULED_DATE_TIME',
    TRANSACTION_DATE = 'TRANSACTION_DATE',
    STATE = 'STATE',
}

//PENDING/NOT_READY/PROCESSING/SUCCEEDED/FAILED/CANCELED

export enum EProListingBillingStatus {
    PENDING = 'PENDING',
    PROVIDER_NOT_READY = 'PROVIDER_NOT_READY',
    PROCESSING = 'PROCESSING',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED',
    CANCELED = 'CANCELED',
}

export enum EFreeCreditBillingStatus {
    PENDING = 'PENDING',
    PROVIDER_NOT_READY = 'PROVIDER_NOT_READY',
    PROCESSING = 'PROCESSING',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED',
    CANCELED = 'CANCELED',
}

export enum EProListingOrderKey {
    PRO_LISTING_FEE = 'PRO_LISTING_FEE',
    ISSUED_DATE = 'ISSUED_DATE',
}

export enum EFreeCreditOrderKey {
    ISSUED_DATE = 'ISSUED_DATE',
    AMOUNT = 'AMOUNT',
}

//PENDING/NOT_READY/PROCESSING/SUCCEEDED/FAILED/CANCELED

export enum ELeadGenBillingStatus {
    PENDING = 'PENDING',
    PROVIDER_NOT_READY = 'PROVIDER_NOT_READY',
    PROCESSING = 'PROCESSING',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED',
    CANCELED = 'CANCELED',
}

export type TGetPaymentBillingLeadgenFeeList = {
    current: number;
    size: number;
    appointmentId: string;
    providerName: string;
    specialty: string[];
    billingStatus: ELeadGenBillingStatus[];
    leadGenOrderKey: ELeadGenOrderKey;
    orderType: 'DESC' | 'ASC';
};

export type TGetPaymentBillingProListingFeeList = {
    current: number;
    size: number;
    billingId: string;
    billingStatus: EProListingBillingStatus[];
    proListingFeeOrderKey: EProListingOrderKey;
    orderType: 'DESC' | 'ASC';
};

export type TGetPaymentBillingFreeCreditList = {
    current: number;
    size: number;
    amount: number[];
    source: string;
    providerCreditsOrderKey: EFreeCreditOrderKey;
    orderType: 'DESC' | 'ASC';
};

export type TBillingLeadGenFeeItem = {
    id: string;
    invoiceId: string;
    appointmentId: number;
    specialty: string;
    appointmentGenFee: number;
    appointmentGenFeeAmount: number;
    billingStatus: ELeadGenBillingStatus;
    appointmentDateTime: string;
    appointmentEndDateTime: string;
    rescheduledDateTime?: string | null;
    rescheduledEndDateTime?: string | null;
    appointmentDuration: number;
    transactionDate: string;
    refundAmountCents: number;
    refundAmount: number;
    refundReason: string;
    klarityTeamNotes?: string | null;
    stripeInvoiceId: string;
    externalInvoicePlatform: string;
    externalInvoiceId: string;
    billingId: number;
    state?: string;
    // Provider attribution for the group practice "Practice View".
    providerName?: string;
    providerAvatar?: string;
    providerCredential?: string;
    providerTitle?: string;
    providerId?: number;
};

// {
//     "billingId": 290,
//     "stripeInvoiceId": "",
//     "externalInvoicePlatform": "STRIPE",
//     "externalInvoiceId": "",
//     "invoiceId": "",
//     "proListingFee": 0,
//     "proListingFeeAmount": 0.00,
//     "billingStatus": "SUCCEEDED",
//     "issuedDate": "2025-10-22T06:00:00",
//     "chargeSucceedAt": "2025-10-22T06:00:00"
// },

export type TBillingProListingFeeItem = {
    billingId: number;
    stripeInvoiceId: string;
    externalInvoicePlatform: string;
    externalInvoiceId: string;
    invoiceId: string;
    proListingFee: number;
    proListingFeeAmount: number;
    billingStatus: EProListingBillingStatus;
    issuedDate: string;
    chargeSucceedAt: string;
    // Provider attribution for the group practice "Practice View" (nested or flat shape).
    provider?: {
        avatar?: string;
        firstName?: string;
        lastName?: string;
        providerId?: number;
    };
    providerFirstName?: string;
    providerLastName?: string;
};

// {
//     "id": 12,
//     "providerId": 1446,
//     "creditType": "PRO_LISTING_GIFT",
//     "totalCents": 30000,
//     "totalCentsAmount": 300.00,
//     "usedCents": 4000,
//     "remainingCents": 26000,
//     "reason": "First time join ad system gift",
//     "usageScenario": "ADVERTISING_FEE",
//     "createdAt": "2025-09-10T01:52:05",
//     "updatedAt": "2025-10-22T06:00:01",
//     "expiresAt": "2026-09-10T01:52:05"
// }

export type TBillingFreeCreditItem = {
    id: number;
    providerId: number;
    creditType: string;
    totalCents: number;
    totalCentsAmount: number;
    usedCents: number;
    remainingCents: number;
    reason: string;
    usageScenario: string;
    createdAt: string;
    updatedAt: string;
    expiresAt: string;
    // Provider attribution for the group practice "Practice View" (nested or flat shape).
    provider?: {
        avatar?: string;
        firstName?: string;
        lastName?: string;
        providerId?: number;
    };
    providerFirstName?: string;
    providerLastName?: string;
};

// {
//     "productId": "3feaad7a-2909-45ce-a647-bb8d4f54f39a",
//     "productStatus": "CURRENT",
//     "totalLimitCents": 10000000,
//     "pricePlans": [
//         {
//             "pricePlanId": "10e74660-b1b6-4b37-a297-293f8c0a80d6",
//             "transactionFeePercentage": 2,
//             "advanceRatePercentage": 100,
//             "repaymentType": "FIXED_DURATION",
//             "repaymentDurationDays": 30,
//             "selected": true
//         },
//         {
//             "pricePlanId": "302e90bf-e644-47ab-aa65-a221e9639ff1",
//             "transactionFeePercentage": 3,
//             "advanceRatePercentage": 100,
//             "repaymentType": "FIXED_DURATION",
//             "repaymentDurationDays": 60,
//             "selected": false
//         }
//     ]
// }

export type TKanmonPricePlan = {
    pricePlanId: string;
    transactionFeePercentage: number;
    advanceRatePercentage: number;
    repaymentType: string;
    repaymentDurationDays: number;
    selected: boolean;
};

export type TKanmonProduct = {
    productId: string;
    productStatus: string;
    totalLimitCents: number;
    pricePlans: TKanmonPricePlan[];
};

export type TProListingFeeSummary = {
    freeCreditsRemaining: number;
    freeCreditsTotal: number;
    totalProListingFeeInvestment: number;
};

// ---- Listing billing banner (GET /schedule-server/provider/billing/listing-banner) ----
// The backend decides which banner to show via `bannerType`; the frontend never
// computes thresholds or listing state. All amounts are in cents (÷100 to display).
export type BannerType = 'NONE' | 'LEAD_GEN_OFFLINE' | 'PRO_LISTING_WARNING' | 'PRO_LISTING_OFFLINE' | 'BOTH_OFFLINE';

export interface ProviderListingBannerVo {
    providerId: number;
    firstName: string | null; // present inside org.affectedProviders for the team owner/admin view
    lastName: string | null;
    listingStatus: string | null; // "L" | "PL" | null
    listingPaused: boolean;
    listingStatusChangeBy: string | null;
    bannerType: BannerType;
    leadGenFailedCents: number;
    proListingFailedCents: number;
}

export interface OrgListingBannerVo {
    organizationId: number;
    orgListingStatus: string | null;
    orgListingPaused: boolean;
    bannerType: BannerType;
    orgLeadGenFailedCents: number;
    orgProListingFailedCents: number;
    totalFailedCents: number;
    affectedProviderCount: number;
    affectedProviders: ProviderListingBannerVo[];
}

export interface ListingBillingBannerVo {
    self: ProviderListingBannerVo; // current provider (individual view)
    groupPractice: boolean; // = (org != null)
    org: OrgListingBannerVo | null; // only present for multi-member groups
}

export interface AdminProviderBillingOverdueVo {
    providerId: number;
    listingStatus: string | null; // "L" | "PL" | null
    listingPaused: boolean;
    listingStatusChangeBy: string | null; // pause reason, e.g. APPOINTMENT_BILLING_FAILED / PRO_LISTING_BILLING_OVERDUE / OPS / PROVIDER
    bannerType: BannerType;
    leadGenFailedCents: number;
    proListingFailedCents: number;
}

// ---- Credentialing · Panel deposits (financials) ----
// GET /schedule-server/provider/credentialing/deposit/{list,summary}
// GET /schedule-server/provider/credentialing/deposit/practice/{list,summary}

// 每行是一个 panel，不是一张发票。后端 credentialingDepositListPage 已经把 billing 级状态
// 折算成 panel 级：本 panel 有成功退款行 -> REFUNDED，退款在途 -> REFUND_PROCESSING，
// 其余落回 billing_status。所以这里**不要**加 PARTIALLY_REFUNDED / REFUNDED_PROCESSING ——
// 那是 billing 级概念（一张聚合发票退了其中几个 panel），panel 级只有全退或不退，
// 加进来会让同一张发票下没退款的 panel 也被标成已退。
export enum ECredentialingDepositBillingStatus {
    PENDING = 'PENDING',
    PROVIDER_NOT_READY = 'PROVIDER_NOT_READY',
    PROCESSING = 'PROCESSING',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED',
    CANCELED = 'CANCELED',
    REFUNDED = 'REFUNDED',
    REFUND_PROCESSING = 'REFUND_PROCESSING',
}

export enum ECredentialingDepositBillingStatusLabel {
    PENDING = 'Pending',
    PROVIDER_NOT_READY = 'Not started',
    PROCESSING = 'Processing',
    SUCCEEDED = 'Collected',
    FAILED = 'Failed',
    CANCELED = 'Canceled',
    REFUNDED = 'Refunded',
    REFUND_PROCESSING = 'Refund processing',
}

export type TCredentialingDepositItem = {
    id: number;
    amountCents: number;
    payerName: string;
    payerState?: string;
    billingStatus: ECredentialingDepositBillingStatus;
    chargeSucceedAt?: string | null;
    // Provider attribution for the group practice "Practice View".
    providerName?: string;
    providerCredential?: string;
    providerAvatar?: string;
};

export type TGetCredentialingDepositListParams = {
    current?: number;
    size?: number;
    depositId?: number;
    payerName?: string;
    providerName?: string;
    billingStatus?: ECredentialingDepositBillingStatus[];
    periodMonths?: number;
    orderKey?: string;
    orderType?: 'ASC' | 'DESC';
};

export type TCredentialingDepositSummary = {
    totalCents: number;
    collectedCents: number;
    outstandingCents: number;
};

// ---------------- Insurance Billing Invoices（Financials → Insurance 面板的月度 managed billing fee 账单）----------------
// GET /provider/insurance-billing/invoices[/summary|/{id}|/{id}/pdf]，只读；字段与后端 1:1。
// 金额与折扣均为后端算好的值，前端不要自己乘费率或遍历 lines 求和（费率 4 位小数有舍入、先舍入再求和 ≠ 先求和再舍入）

// 库中原值，后端不翻译；OVERDUE 枚举存在但线上从不写入 —— 逾期由前端用 dueDate 推导
export type TInvoiceStatus = 'INITIAL' | 'SENT' | 'PAID' | 'OVERDUE';

export type TInvoiceSortBy = 'billingPeriod' | 'reimbursed' | 'discount' | 'fee' | 'issueDate';

export interface InvoiceListParams {
    // 按签发日回溯 N 个月的滑动窗口（不是自然月），1-6，默认 1
    months?: number;
    // 账单号模糊匹配
    keyword?: string;
    // 逗号分隔的 TInvoiceStatus 集合
    status?: string;
    sortBy?: TInvoiceSortBy;
    sortDir?: 'asc' | 'desc';
    page?: number;
    // <=100，默认 20
    limit?: number;
}

export interface InvoiceListItemVo {
    invoiceId: number;
    // 完整编号（如 INV-202608-1025），是系统身份证，原样渲染、不要截短
    invoiceNumber: string;
    // 'YYYY-MM-DD'
    billingFrom?: string;
    billingTo?: string;
    // 赔付总额（payer 打给 provider 的钱，不是 Klarity 收的）
    reimbursed?: number;
    // 标准价与实际价的差额，展示为负数
    discount?: number;
    // provider 实际欠 Klarity 的金额
    fee?: number;
    status?: TInvoiceStatus;
    // 'YYYY-MM-DD'
    issueDate?: string;
    // 列表不展示，明细 meta 行与前端逾期推导要用
    dueDate?: string;
    pdfAvailable?: boolean;
}

export interface InvoiceListMeta {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

// 列表分页结构：响应信封 data 里再嵌一层 data + meta（仅列表接口如此，summary/明细为单层）
export interface InvoiceListVo {
    data: InvoiceListItemVo[];
    meta: InvoiceListMeta;
}

// summary 与列表口径一致（同 months/keyword/status），是整个筛选区间的合计，不是当前页
export interface InvoiceSummaryVo {
    reimbursedTotal?: number;
    feeTotal?: number;
    // 展示为负数
    discountTotal?: number;
}

export interface InvoiceLineVo {
    claimId?: number;
    // 后端已脱敏（"Linda P*"），直接渲染，不要二次处理
    patientName?: string;
    payerName?: string;
    // 'YYYY-MM-DD'
    serviceDate?: string;
    paidDate?: string;
    reimbursed?: number;
    // 小数（0.0390 → 3.9%），且为 4 位舍入值，不能用来复算金额
    regularRate?: number;
    providerRate?: number;
    discount?: number;
    fee?: number;
    feeType?: 'PERCENT' | 'FLAT';
}

export interface InvoiceDetailVo extends InvoiceListItemVo {
    // 合计行直接用头表 reimbursed/discount/fee（后端已保证勾稽一致），不要遍历 lines 求和
    lines?: InvoiceLineVo[];
}

// S3 预签名短链（900 秒过期），每次点击现取，不要缓存；已带 attachment，直接跳转即下载
export interface InvoicePdfLinkVo {
    url?: string;
    expiresAt?: string;
}
